import React, { useState, useCallback, useEffect } from 'react';

const SidebarLinkGroup = React.memo(({
  children,
  activecondition,
}) => {

  const [open, setOpen] = useState(activecondition);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [open]);

  useEffect(() => {
    setOpen(activecondition);
  }, [activecondition]);

  return (
    <li className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${activecondition && 'bg-slate-900'}`}>
      {children(handleClick, open)}
    </li>
  );
});

SidebarLinkGroup.displayName = 'SidebarLinkGroup';

export default SidebarLinkGroup;